import { createContext, useContext } from 'react';
import useEasyModeCase from '../hooks/useEasyModeCase';

const EasyModeContext = createContext(null);

export const EasyModeProvider = ({ children }) => {
  const easyModeState = useEasyModeCase();

  return (
    <EasyModeContext.Provider value={easyModeState}>
      {children}
    </EasyModeContext.Provider>
  );
};

export const useEasyModeContext = () => {
  const context = useContext(EasyModeContext);

  if (!context) {
    throw new Error('useEasyModeContext must be used within EasyModeProvider');
  }

  return context;
};

export default EasyModeContext;
